import { render } from "./user.vue?vue&type=template&id=b940a01e&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=b940a01e&lang=scss&scoped=true"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b940a01e"]])

export default __exports__